module.exports = __webpack_public_path__ + "static/media/ajout-message.03935e90.png";